
import { Object3D } from 'three';
import { globalManager } from './globalConfig';
import { VisionaryObject } from '@/visionaryControllers/visionaryScene';

export class ModelUtils {
    /**
     * 更新对象位置
     * @param id 对象ID
     * @param value X轴位置值
     */
    onPositionChange(value: { x: number, y: number, z: number }): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.updateObjectPosition(currentSelected.objectid, value);
            this.onModelParamsChange('position', value);
        }
    }

    onRotationChange(value: { x: number, y: number, z: number }): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.updateObjectRotation(currentSelected.objectid, value);
            this.onModelParamsChange('rotation', value);
        }
    }

    onScaleChange(value: { x: number, y: number, z: number }): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.updateObjectScale(currentSelected.objectid, value);
            this.onModelParamsChange('scale', value);
        }
    }

    onRecordingCameraChange(): void {
        const currentSelected = globalManager.getCurrentSelected();
        const object = globalManager.getCurrentObject();
        if (object && object.type === 'recordingCamera') {
            const sceneInfos = globalManager.getAllSceneInfos();
            for (const sceneInfo of sceneInfos) {
                if (sceneInfo.scene && sceneInfo.scene.getId() !== currentSelected.sceneid) {
                    sceneInfo.scene.syncRecordingCameraByObject(object);
                }
            }
        }

    }

    onModelParamsChange(type: 'position' | 'rotation' | 'scale' | 'fov' | 'near' | 'far', value: any): void {
        const currentSelected = globalManager.getCurrentSelected();
        const object = globalManager.getCurrentObject();
        if (object) {
            if (object.type === 'recordingCamera') {
                const sceneInfos = globalManager.getAllSceneInfos();
                for (const sceneInfo of sceneInfos) {
                    if (sceneInfo.scene && sceneInfo.scene.getId() !== currentSelected.sceneid) {
                        sceneInfo.scene.syncRecordingCameraParams(type, value);
                    }
                }
            }
        }
    }
    // 高斯大小倍数
    onGaussianSizeChange(value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelGaussianParams(currentSelected.objectid, 'gaussianScale', value);
        }
    }
    // 高斯透明度倍数
    onGaussianOpacityChange(value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelGaussianParams(currentSelected.objectid, 'opacityScale', value);
        }
    }
    // 球谐函数等级
    onSphericalLevelChange(value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelGaussianParams(currentSelected.objectid, 'maxShDeg', value);
        }
    }
    // 时间缩放倍数
    onTimeScaleChange(value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelGaussianParams(currentSelected.objectid, 'timeScale', value);
        }
    }
    // 时间偏移量
    onTimeOffsetChange(value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelGaussianParams(currentSelected.objectid, 'timeOffset', value);
        }
    }
    // 最大像素半径
    // onMaxPixelRadiusChange(value: number): void {
    //     const currentSelected = globalManager.getCurrentSelected();
    //     const scene = globalManager.getCurrentSceneView();
    //     if (scene) {
    //         scene.setModelGaussianParams(currentSelected.objectid, 'maxPixelRadius', value);
    //     }
    // }
    // 循环播放
    onLoopChange(value: boolean): void {
        const currentSelected = globalManager.getCurrentSelected();
        const scene = globalManager.getCurrentSceneView();
        if (scene) {
            scene.setModelLoop(currentSelected.objectid, value);
        }
    }
    // 录制相机参数设置 - FOV、近平面、远平面
    onRecordingCameraParamsChange(type: 'fov' | 'near' | 'far', value: number): void {
        const currentSelected = globalManager.getCurrentSelected();
        const sceneInfos = globalManager.getAllSceneInfos();
        for (const sceneInfo of sceneInfos) {
            if (sceneInfo.scene && sceneInfo.scene.getId() === currentSelected.sceneid) {
                sceneInfo.scene.setRecordingParams(currentSelected.objectid,type, value);
            } else {
                sceneInfo.scene?.syncRecordingCameraParams(type, value);
            }
        }
    }
}

// 创建并导出单例实例
const modelUtils = new ModelUtils();
export { modelUtils };